import { render, staticRenderFns } from "./mappingDetailTable.vue?vue&type=template&id=cc79a326&scoped=true&"
import script from "./mappingDetailTable.vue?vue&type=script&lang=js&"
export * from "./mappingDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./mappingDetailTable.vue?vue&type=style&index=0&id=cc79a326&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc79a326",
  null
  
)

export default component.exports